import React, { useState } from 'react';
import { producaov2 } from '../../../../services/apis';
import { toast } from 'react-toastify';
import { Box, CircularProgress, IconButton } from '@material-ui/core';
import { RemoveCircleOutline, Visibility } from '@material-ui/icons';

export default function UserActions({ defaultFileUrl, feedbackUrl, applicationID, applicationPhaseID, onReset = () => {} }) {
  const [loadingDeleteStep, setLoadingDeleteStep] = useState(false);
  const [fileUrl, setFileUrl] = useState(defaultFileUrl);

  const handleResetSent = async () => {
    setLoadingDeleteStep(true);

    try {
      if(feedbackUrl) {
        const willReset = await swal({
          title: 'Aviso',
          text: 'Existe um feedback nessa etapa, resetar a etapa do aluno irá remover o feedback também. Deseja continuar?',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        });

        if(!willReset) {
          return;
        }
      }

      await producaov2.delete(`/admin/project-applications/${applicationID}/phases/${applicationPhaseID}`);

      setFileUrl('');
      toast.success('Envio do aluno resetado com sucesso');

      onReset();
    } catch(error) {
      console.log(error);

      toast.error('Houve um erro ao resetar a etapa do aluno');
    } finally {
      setLoadingDeleteStep(false);
    }
  }

  return (
    <Box display="flex">
      <IconButton title="Visualizar envio do aluno" component="a" size="small" href={fileUrl} target="_blank">
        <Visibility />
      </IconButton>
      {/**Comentado temporariamente */}
      {/* {!!fileUrl && (
        <IconButton title="Resetar envio do aluno" size="small" disabled={loadingDeleteStep} onClick={handleResetSent}>
          {loadingDeleteStep ? <CircularProgress size={14} /> : <RemoveCircleOutline color="error" />}
        </IconButton>
      )} */}
    </Box>
  )
}